module.exports = __webpack_public_path__ + "37ba7b92/img/product-icon-grey.b248963c.svg";